<template>
	
	<div class="addingAccountsWidget" v-if="adding">
		<div class="float-left">Searching for new accounts . . .</div><div class="float-right" @click="adding=false; this.$cookies.remove('waitBank');">Cancel</div>
		<v-progress-linear indeterminate color="#332847"></v-progress-linear>
	</div>
	
</template>

<script>
import Services from '../../mixins/Services';

export default {
	name: "AwaitBankAccountPanel",
	mixins: [Services],
	props: {
		origCount: {
			type: Number,
			required: true
		}
	},
	data() {
		return{
			adding: true
		}
	},
	methods: {
		onLoad() {
			this.waitLinkedAccount();
		},
		waitLinkedAccount: function(){
			this.interval = setInterval(() => {
				if (!this.adding) { clearInterval(this.interval); return; }
				this._clearBankingInfo();
				this._getBankingInfo(() => {
					if (this.bankInfo.accounts.length > this.origCount)
					{
						this.adding = false;
						this.$cookies.remove('waitBank');
						this.$emit('accountAdded');
						clearInterval(this.interval); return;
					}
				});
			}, 5000);
		},
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.addingAccountsWidget {
	h--eight: 50px;
	b--order-bottom: 1px solid #e0e0e0;
	margin-left: -30px;
	margin-right: -30px;
	margin-bottom: 30px;
	margin-top: -20px;
	b--order-bottom-right-radius: 20px;
	b--order-bottom-left-radius: 20px;
	padding: 20px;
	background: linear-gradient(243.52deg, #FCE5D4 18.85%, #E0C5C8 81.37%);
	transition: all 1s ease-out;
}


</style>